import { IS_FLIPGIVE } from 'common/env';

// FlipGive-scoped account menu URLs (used by the top-nav menu and the coordinator dashboard header).
// RaiseRight keeps its existing relative routes; only FlipGive needs these absolute marketing URLs.
export const FlipGiveAccountMenuUrls = {
    browserExtension:
        'https://www.flipgive.com/m/extension?utm_source=react_web&utm_medium=banner&utm_campaign=bex_web_install_menu',
    contactUs: 'https://www.flipgive.com/about-us/contact/',
    helpCenter:
        'https://help.flipgive.com/?utm_campaign=help_center&utm_medium=account_dropdown&utm_source=react_web',
    coordinatorResources: 'https://www.flipgive.com/resources/organization/',
    participantResources: 'https://www.flipgive.com/resources/participant/',
} as const;

export const ExternalLinks = {
    get HelpCenterAccountDropdown() {
        const DropdownRaiserightHelpCenter =
            'https://support.raiseright.com/hc?utm_source=react_web&utm_medium=account_dropdown&utm_campaign=help_center';
        return IS_FLIPGIVE ? FlipGiveAccountMenuUrls.helpCenter : DropdownRaiserightHelpCenter;
    },
    get BrowserExtensionBanner() {
        return IS_FLIPGIVE
            ? 'https://www.flipgive.com/m/extension?utm_source=react_web&utm_medium=banner&utm_campaign=bex_web_install_banner'
            : 'https://www.raiseright.com/m/extension?utm_source=react_web&utm_medium=banner&utm_campaign=bex_web_install_banner';
    },
    // Guided onboarding extension step (FEC-2804): store link per brand + browser.
    get OnboardingExtensionChromeStore() {
        return IS_FLIPGIVE
            ? 'https://chromewebstore.google.com/detail/flipgive-earnings-extensi/aoljonbhacccfmnfknimhpldbikaeghl?utm_source=react_web&utm_medium=onboarding&utm_campaign=guided_onboarding'
            : 'https://chromewebstore.google.com/detail/raiseright-earnings-exten/gkooddoikifbkijghlkeciopdlffjdmd?utm_source=react_web&utm_medium=onboarding&utm_campaign=guided_onboarding';
    },
    get OnboardingExtensionEdgeStore() {
        return IS_FLIPGIVE
            ? 'https://microsoftedge.microsoft.com/addons/detail/flipgive-earnings-extensi/jngoheiedbmnfhhldpabngmmaipdngeb?utm_source=react_web&utm_medium=onboarding&utm_campaign=guided_onboarding'
            : 'https://microsoftedge.microsoft.com/addons/detail/raiseright-earnings-exten/opobjpgfgfnndocpbhfeanjebjahlnkl?utm_source=react_web&utm_medium=onboarding&utm_campaign=guided_onboarding';
    },
    get ParticipantTermsOfUse() {
        return IS_FLIPGIVE
            ? 'https://www.flipgive.com/about-us/participant-terms-of-use/'
            : 'https://www.raiseright.com/about-us/participant-terms-of-use/';
    },
    get PrivacyPolicy() {
        return IS_FLIPGIVE
            ? 'https://www.flipgive.com/about-us/privacy-policy/'
            : 'https://www.raiseright.com/about-us/privacy-policy/';
    },
    get TermsOfUse() {
        return IS_FLIPGIVE
            ? 'https://www.flipgive.com/about-us/terms-of-use/'
            : 'https://www.raiseright.com/about-us/terms-of-use/';
    },
    get OrganizationTermsOfUse() {
        return IS_FLIPGIVE
            ? 'https://www.flipgive.com/about-us/organization-terms-of-use/'
            : 'https://www.raiseright.com/about-us/organization-terms-of-use/';
    },
    get HelpCenterFooter() {
        const FooterFlipgiveHelpCenter = 'https://help.flipgive.com/';
        const FooterRaiserightHelpCenter =
            'https://support.raiseright.com/hc?utm_source=react_web&utm_medium=footer&utm_campaign=help_center';

        return IS_FLIPGIVE ? FooterFlipgiveHelpCenter : FooterRaiserightHelpCenter;
    },
    get Facebook() {
        return IS_FLIPGIVE
            ? 'https://www.facebook.com/FlipGive/'
            : 'https://www.facebook.com/RaiseRightFundraising';
    },
    get LinkedIn() {
        return IS_FLIPGIVE
            ? 'https://www.linkedin.com/company/flipgive/'
            : 'https://www.linkedin.com/company/raiseright/';
    },
    get Youtube() {
        return IS_FLIPGIVE
            ? 'https://www.youtube.com/c/FlipGive'
            : 'https://www.youtube.com/@raiseright';
    },
    get Instagram() {
        return IS_FLIPGIVE
            ? 'https://www.instagram.com/flipgive/'
            : 'https://www.instagram.com/raiserightfundraising/';
    },
    get InviteP2PLearnMore() {
        return IS_FLIPGIVE
            ? 'https://help.flipgive.com/articles/how-to-enable-or-disable-invite-friends-family-for-your-organization'
            : 'https://www.raiseright.com/m/invite-settings';
    },
};

export const GooglePlayStoreUrl = IS_FLIPGIVE
    ? 'https://play.google.com/store/apps/details?id=com.flipgive.app&hl=en_CA&pli=1&external=true'
    : 'https://play.google.com/store/apps/details?id=com.shopwithscrip.app&hl=en_US&gl=US';

export const ApplePlayStoreUrl = IS_FLIPGIVE
    ? 'https://apps.apple.com/ca/app/flipgive-fund-youth-sports/id1382434604?external=true'
    : 'https://apps.apple.com/us/app/raiseright-fundraising/id1498234012';
